export default __webpack_public_path__ + "static/media/stock.d2a17777.svg";